var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertSolid = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.2636 18.4692C22.9366 19.594 22.0919 21 20.7478 21H3.25198C1.90532 21 1.06452 19.5918 1.73615 18.4692L10.4842 3.84322C11.1575 2.71791 12.8438 2.71995 13.5158 3.84322L22.2636 18.4692ZM13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5C10.5 15.6716 11.1716 15 12 15C12.8284 15 13.5 15.6716 13.5 16.5ZM11.3287 6C10.885 6 10.5383 6.38311 10.5825 6.82463L11.1825 12.8246C11.2208 13.208 11.5434 13.5 11.9287 13.5H12.0713C12.4566 13.5 12.7792 13.208 12.8175 12.8246L13.4175 6.82463C13.4617 6.38311 13.115 6 12.6713 6H11.3287Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert-solid.92cc8d0bd182523aa14b6908c7b55138.svg";